"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToastPosition = exports.TOAST_OFFSET = exports.TOAST_POSITIONS = void 0;
const path_1 = require("@/app/shared/router/path");
const react_router_dom_1 = require("react-router-dom");
exports.TOAST_POSITIONS = {
    [path_1.PathMeetingBooker.LOGIN]: 'top-right',
    [path_1.PathMeetingBooker.HOME]: 'top-center',
    default: 'top-right',
};
exports.TOAST_OFFSET = {
    [path_1.PathMeetingBooker.LOGIN]: 'top-43px right-20px',
    [path_1.PathMeetingBooker.HOME]: 'top-43px right-20px',
    default: 'top-43px right-20px',
};
const useToastPosition = () => {
    const location = (0, react_router_dom_1.useLocation)();
    return {
        position: exports.TOAST_POSITIONS[location.pathname] || exports.TOAST_POSITIONS.default,
        offset: exports.TOAST_OFFSET[location.pathname] || exports.TOAST_OFFSET.default,
    };
};
exports.useToastPosition = useToastPosition;
